import { TableColumn } from "react-data-table-component";
import { Link } from "react-router-dom";
import { LI, UL } from "../../AbstractElements";
import { PaymentRowType } from "../../Types/PaymentManagement";
import {
  CompanyRoleTableActionTypes,
  FormAccess,
} from "../../Types/UserManagement";
import { PaymentManagementRoute } from "../../utils/Constant";

export const PaymentColumnStructure: TableColumn<PaymentRowType>[] = [
  {
    name: "Payment ID",
    selector: (row) => row.id,  
    sortable: true,
    center: false,
  },
 
  {
    name: "Request ID",
    selector: (row) => row.reqId, // Corrected to use 'reqId'
    sortable: true,
    center: false,
  },
  {
    name: "Service/Rental",
    selector: (row) => row.type, // Using 'name' for Service/Rental
    sortable: true,
    center: false,
  },
  {
    name: "Name",
    selector: (row) => row.name, // Using 'name' for Service/Rental
    sortable: true,
    center: false,
  },
  {
    name: "Amount",
    selector: (row) => `$ ${row.amount}`,  
    sortable: true,
    center: false,
  },
  {
    name: "Status",
    selector: (row) => row.status, // 'status' is correctly used here
    sortable: true,
    center: false,
  },
  {
    name: "User Type",
    selector: (row) => row.userId === 'N/A' ? 'Guest User' : 'Registered User' ,  
    sortable: true,
    center: false,
  },
  {
    name: "User Name",
    selector: (row) => row.username ,  
    sortable: true,
    center: false,
  },
  {
    name: "User Email",
    selector: (row) => row.useremail ,  
    sortable: true,
    center: false,
  },
  // {
  //   name: "Action",
  //   cell: (row) => (
  //     <TableActions
  //       id={row.id} // 'id' is used here for the action row
  //       setCentered={row.setCentered}
  //       modalDetails={row.modalDetails}
  //     />
  //   ),
  //   sortable: false, // Actions are typically not sortable
  //   center: true,
  // },
];

// Updated TableActions component to correctly handle props
const TableActions: React.FC<CompanyRoleTableActionTypes> = ({
  id,
  setCentered,
  modalDetails,
}) => {
  const handleDeleteClick = () => {
    if (setCentered) setCentered(true);
    if (modalDetails) {
      modalDetails({
        id,
        type: FormAccess.DELETE,
      });
    }
  };

  return (
    <UL className="action simple-list flex-row gap-2" id={id}>
      <LI className="create" aria-disabled onClick={handleDeleteClick}>
        <Link to={`/${PaymentManagementRoute}/${id}`}>
          <i className="fa fa-bars" />
        </Link>
      </LI>
    </UL>
  );
};
